import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { IEvent, ISport } from "bets.oddprovider.lib.common.ts/models"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { FormItemStyled } from "fwork.react.apptemplate"
import { useSnackbar } from "notistack"
import React, { useEffect, useState } from "react"
import axios from "../../apiClient/axios"
import { SportsApiClient } from "../../apiClient/sports"
import { DEFAULTGAP } from "../../globals"

export const EventSportComponent = (props: {
  data?: IEvent,
  onChange: ((event: SelectChangeEvent<number>, child: React.ReactNode) => void) | undefined
}) => {
  const [data, setData] = useState<ISport[]>([])
  const { enqueueSnackbar } = useSnackbar()

  const [gettingData, setGettingData] = useState<boolean>(false)
  const getData = async (filter: string | undefined) => {
    if (gettingData) return
    setGettingData(true)

    try {
      const response = await new SportsApiClient(axios).get({
        where: {
          name: { $regex: filter || '', $options: 'i' }
        },
        sort: { name: 1 }
      })

      setData(response.data?.payload ?? [])
      return response.data?.payload
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
      setGettingData(false)
    }
  }

  useEffect(() => {
    getData(undefined)
  }, [])

  return data.length ? <FormItemStyled gap={DEFAULTGAP}>
    <FormControl fullWidth>
      <InputLabel id="sport-label">Sport</InputLabel>
      <Select
        labelId="sport-label"
        id="input-label"
        value={props.data?.sport_id ?? ''}
        label={data.filter(s => s.id == props.data?.sport_id)[0]?.name ?? ''}
        onChange={props.onChange}
      >
        {data.map(s => <MenuItem key={s.id} value={s.id}>{s.name}</MenuItem>)}
      </Select>
    </FormControl>
  </FormItemStyled> : <></>
}